import { useQuery } from '@tanstack/react-query';
import { JSONContent } from '@tiptap/core';
import { useMemo } from 'react';

import { useProductCenterApi } from 'api';
import { releaseNoteContentQuery } from 'api/queries';
import RichText from 'library/components/controls/richtexteditor/RichText';
import { IsExternal } from 'library/types';

interface ReleaseNoteAccordionContentProps extends IsExternal {
	id: number;
}

export const ReleaseNoteAccordionContent = ({
	id,
	isExternal,
}: ReleaseNoteAccordionContentProps) => {
	const { api } = useProductCenterApi();
	const { data } = useQuery(releaseNoteContentQuery(api, id));
	const { internalContent, externalContent } = data ?? {};

	const content = useMemo(
		() => (isExternal ? externalContent : internalContent),
		[externalContent, internalContent, isExternal]
	);
	const parsedContent = useMemo(
		() => (content ? (JSON.parse(content) as JSONContent) : ''),
		[content]
	);

	return <RichText content={parsedContent} />;
};
